import {
  PinwheelFlowPageResultTypenames,
  Query,
} from '@varo/graphql-schema-types';
import PinwheelFlowTypename from 'services/graphql/queries/pinwheel/PinwheelFlowTypename.query';
import { CombinedError, useQuery } from 'urql';

interface UsePinwheelFlowPageTypenameInput {
  pause?: boolean;
}

export enum PinwheelFlowPageStatus {
  DdSetupRequired = 'DdSetupRequired',
  DdSetupNotRequired = 'DdSetupNotRequired',
  Error = 'Error',
}

export type PinwheelFlowPageState =
  | { status: PinwheelFlowPageStatus.DdSetupRequired }
  | { status: PinwheelFlowPageStatus.DdSetupNotRequired }
  | { status: PinwheelFlowPageStatus.Error; error?: CombinedError };

export interface UsePinwheelFlowPageTypenameResult {
  result: PinwheelFlowPageState | null;
  fetching: boolean;
}

/**
 * `null` means the query has not settled yet. Callers must treat it as
 * pending rather than as a negative answer.
 */
const toPinwheelFlowPageState = (
  data: Query | undefined,
  error: CombinedError | undefined,
): PinwheelFlowPageState | null => {
  if (error) {
    return { status: PinwheelFlowPageStatus.Error, error };
  }

  if (data === undefined) {
    return null;
  }

  const typename = data.pinwheelFlowPage?.__typename;

  if (typename === PinwheelFlowPageResultTypenames.PinwheelFlowPageError) {
    return { status: PinwheelFlowPageStatus.Error };
  }

  if (typename === PinwheelFlowPageResultTypenames.DdPinwheelSetupPage) {
    return { status: PinwheelFlowPageStatus.DdSetupRequired };
  }

  return { status: PinwheelFlowPageStatus.DdSetupNotRequired };
};

const usePinwheelFlowPageTypename = ({
  pause = false,
}: UsePinwheelFlowPageTypenameInput = {}): UsePinwheelFlowPageTypenameResult => {
  const [{ data, error, fetching }] = useQuery<Query>({
    query: PinwheelFlowTypename,
    pause,
  });

  return {
    result: toPinwheelFlowPageState(data, error),
    fetching,
  };
};

export default usePinwheelFlowPageTypename;
